import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const ProtectedRoute = () => {
    // const loginStatus = window.localStorage.getItem('isLoggedIn');
    const role = window.localStorage.getItem('userType');
    // const isLoggedIn = JSON.parse(loginStatus)
    return role ==="superAdmin" ?  <Sidebar><Outlet/></Sidebar> : <Navigate to="/unauthorizedPage" /> 
};

export default ProtectedRoute;